import { EventEmitter, Injectable } from '@angular/core';
import { Message } from 'primeng/api';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedEventsService {
  public loadingEmitter = new EventEmitter<boolean>();
  public toasterEvents: EventEmitter<any> = new EventEmitter<any>();
  public toasterData = {};
  public openConsentPopup = new Subject<void>();
  private usersData: any;

  isEncodedParameter(value: string) {
    try {
      if (value == '') return false;

      return btoa(atob(value)) === value;
    } catch (error) {
      return false;
    }
  }
  encodeParameterUrl(value: string) {
    return btoa(value);
  }

  decodeBase64(value: string) {
    try {
      return atob(value);
    } catch {
      return null;
    }
  }
  decodeParameterUrl(value: string) {
    let decodedValue = value;
    let base64DecodedValue = null;

    // Decode multiple levels of encoding (if there is multiple %25 after multiple refreshes)
    while (decodedValue) {
      try {
        decodedValue = decodeURIComponent(decodedValue);
      } catch {
        break;
      }

      base64DecodedValue = this.decodeBase64(decodedValue);
      if (base64DecodedValue !== null) {
        return base64DecodedValue;
      }
    }

    return '';
  }

  arrayBufferToBase64(buffer: any) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  isFirefox(): boolean {
    return /Firefox\//i.test(window.navigator.userAgent);
  }

  getAge(dateString: string, referenceDate?: Date) {
    if (!referenceDate) {
      referenceDate = new Date();
    }

    const birthDate = new Date(dateString);
    let age = referenceDate.getFullYear() - birthDate.getFullYear();
    const m = referenceDate.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && referenceDate.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  startLoading(): void {
    this.loadingEmitter.emit(true);
  }

  removeLoading(): void {
    this.loadingEmitter.emit(false);
  }

  emitToasterEvent(data: Message): void {
    this.toasterEvents.emit(data);
  }

  setUsers(users: any) {
    this.usersData = users;
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    let mime = arr[0].match(/:(.*?);/)![1];

    // O browser não reconhece HEIC/HEIF: o File.type vem vazio e readAsDataURL grava
    // 'application/octet-stream', que o backend rejeita por não constar dos mimetypes
    // permitidos. Recuperamos o mimetype a partir da extensão do nome do ficheiro.
    if (!mime || mime === 'application/octet-stream') {
      mime = this.getMimeTypeFromExtension(filename) || mime;
    }

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  /**
   * Devolve o mimetype correspondente à extensão do ficheiro (case-insensitive),
   * para os casos em que o browser não consegue inferir o File.type (ex.: HEIC/HEIF).
   * Devolve '' quando a extensão não é reconhecida.
   *
   * @param filename nome do ficheiro, ex.: 'IMG_1234.HEIC'
   */
  getMimeTypeFromExtension(filename: string): string {
    const ext = filename.split('.').pop()?.toLowerCase() ?? '';
    const map: Record<string, string> = {
      pdf: 'application/pdf',
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      heic: 'image/heic',
      heif: 'image/heif',
      gif: 'image/gif',
      webp: 'image/webp',
      bmp: 'image/bmp',
      tif: 'image/tiff',
      tiff: 'image/tiff'
    };
    return map[ext] ?? '';
  }

  redirectLogin(router: Router) {
    if (sessionStorage.getItem('loginRedirect') !== null && sessionStorage.getItem('loginRedirect')?.toString() !== '') {
      // tslint:disable-next-line:no-non-null-assertion
      if (!sessionStorage.getItem('loginRedirect')!.startsWith('http')) {
        router.navigate(['/login']);
      } else {
        // tslint:disable-next-line:no-non-null-assertion
        window.open(sessionStorage.getItem('loginRedirect')!, '_self');
      }
    } else {
      router.navigate(['/login']);
    }
  }
}
